export default __webpack_public_path__ + "static/media/62.d3a0905b.png";